// extracted by mini-css-extract-plugin
module.exports = {"article-actions":"blog-article_article-actions__3jvEW","article-actions-link":"blog-article_article-actions-link__13Ivm"};